import { cloneElement, isValidElement } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UnauthorizedTooltip = ({
  children,
  tooltipPlacement,
  tooltipMessage
}) => {
  const defaultTooltipMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'account-and-billing-components.UnauthorizedTooltip.billing-write-unauthorized'
  });
  const title = tooltipMessage || defaultTooltipMessage;
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: tooltipPlacement,
    title: title,
    "data-selenium-test": "account-and-billing-ui.unauthorized-tooltip",
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/isValidElement(children) ? /*#__PURE__*/cloneElement(children, {
        disabled: true
      }) : children
    })
  });
};
export default UnauthorizedTooltip;